import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1d0945a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "z-50",
  id: "section-1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "text-white" }
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = { class: "actions text-center" }
const _hoisted_6 = { class: "exclusive text-base text-white pb-1 bold-text" }
const _hoisted_7 = {
  key: 0,
  href: "itms-apps://itunes.apple.com/app/inksquad-artist/id1579690331",
  target: "_blank"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "px-8 py-3 standard-button-blue rounded-full uppercase button-text mx-auto mb-1" }, "Download", -1))
const _hoisted_9 = { class: "exclusive text-xs text-gray-200" }
const _hoisted_10 = {
  key: 1,
  href: "https://itunes.apple.com/app/inksquad-artist/id1579690331",
  target: "_blank"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "px-8 py-3 standard-button-blue rounded-full uppercase button-text mx-auto mb-1" }, "Download", -1))
const _hoisted_12 = { class: "exclusive text-xs text-gray-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleTemplate = _resolveComponent("TitleTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TitleTemplate, null, {
      main: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('components.homepage.inkboards1.title-line-1')), 1),
          _hoisted_2,
          _createTextVNode(_toDisplayString(_ctx.$t('components.homepage.inkboards1.title-line-2')), 1)
        ])
      ]),
      text: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('components.homepage.inkboards1.text-line-1')), 1)
      ]),
      button: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('components.general.availability')), 1),
            (_ctx.operatingSystem.os === 'Mac OS')
              ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('components.general.availability-2')), 1)
                ]))
              : (_openBlock(), _createElementBlock("a", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('components.general.availability-2')), 1)
                ]))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}